import React from "react";
import { useTranslation } from "react-i18next";

import DPCard from "../../../../../../packages/DPCard";
import WPCopyToClipboard from "../../../../../../packages/WPCopyToClipBoard";
import WPHeading from "../../../../../../packages/WPHeading";

import { LICENSE_SUPPORT_EMAIL } from "../UserLicenseDetails.constants";

import "./UserLicenseSupport.scss";

const UserLicenseSupport = () => {
  const { t } = useTranslation();
  const supportEmail = LICENSE_SUPPORT_EMAIL;

  return (
    <DPCard className="user-license-support-container">
      <div
        className="user-license-header-conatiner"
        id="user-license-support-title"
      >
        <WPHeading size="small" type="default" secondary fontNoto>
          {t("licenseProfile.licenseSupport")}
        </WPHeading>
        <div className="user-license-support-email-row">
          <a
            href={`mailto:${supportEmail}`}
            className="user-license-support-email-link"
            id="user-license-support-email-link"
          >
            {supportEmail}
          </a>
          <div
            className="user-license-support-copy-icon"
            id="user-license-support-copy-icon"
          >
            <WPCopyToClipboard text={supportEmail} />
          </div>
        </div>
      </div>
    </DPCard>
  );
};

export default UserLicenseSupport;
